import { createFileRoute, Link } from "@tanstack/react-router";
import { loadAshbyJob } from "~/utils/ashby";
import { seo, seoLinks, jobPostingJsonLd } from "~/utils/seo";
import { Button } from "~/components/Button";

export const Route = createFileRoute("/careers/$jobId")({
  loader: ({ params }) => loadAshbyJob({ data: { id: params.jobId } }),
  head: ({ loaderData, params }) => {
    const url = `/careers/${params.jobId}`;
    if (!loaderData) return { meta: [], links: [] };

    const locationNames = loaderData.locations.map((l) => l.name).join(", ");
    const description = [loaderData.title, loaderData.department, locationNames]
      .filter(Boolean)
      .join(" — ");

    return {
      meta: seo({
        title: `${loaderData.title} - Careers`,
        description: `${description} at C1.`,
        url,
      }),
      links: seoLinks({ url }),
      scripts: [
        jobPostingJsonLd({
          url,
          title: loaderData.title,
          descriptionHtml: loaderData.descriptionHtml,
          datePosted: loaderData.publishedAt,
          department: loaderData.department,
          locations: loaderData.locations,
          isRemote: loaderData.isRemote,
          applyUrl: loaderData.applyUrl,
          salary: loaderData.salary,
        }),
      ],
    };
  },
  component: JobDetail,
});

function JobDetail() {
  const job = Route.useLoaderData();

  return (
    <div className="mx-auto max-w-screen-md px-4 py-14 md:px-8 md:py-20">
      <Link
        to="/careers"
        className="font-body text-14 font-semibold text-teal-dark hover:underline"
      >
        &larr; Back to careers
      </Link>

      <h1 className="mt-6 font-display text-33 font-bold text-charcoal md:text-5xl">
        {job.title}
      </h1>

      <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1 font-body text-14 text-gray-80">
        {job.department && <span>{job.department}</span>}
        {job.locations.length > 0 ? (
          <span>{job.locations.map((l) => l.name).join(", ")}</span>
        ) : (
          job.workplaceType && <span>{job.workplaceType}</span>
        )}
      </div>

      {job.compensationSummary && (
        <p className="mt-4 font-body text-16 font-semibold text-charcoal">
          {job.compensationSummary}
        </p>
      )}

      <div className="mt-8">
        <Button href={job.applyUrl} variant="teal" target="_blank" rel="noopener">
          Apply now
        </Button>
      </div>

      {job.descriptionHtml && (
        <div
          className="content mt-10"
          dangerouslySetInnerHTML={{ __html: job.descriptionHtml }}
        />
      )}

      <div className="mt-10">
        <Button href={job.applyUrl} variant="teal" target="_blank" rel="noopener">
          Apply now
        </Button>
      </div>
    </div>
  );
}
